var _style, _path, _polygon, _path2;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgDsbLogo(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 470 250",
    style: {
      enableBackground: "new 0 0 470 250"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0{fill:url(#SVGID_1_);}\r\n\t.st1{fill:url(#SVGID_00000150799943294895901370000003173121705863639183_);}\r\n\t.st2{fill:url(#SVGID_00000099640042558595751210000011533594817064400272_);}\r\n\t.st3{fill:url(#SVGID_00000132805957741305143840000000757842756081280904_);}\r\n\t.st4{fill:url(#SVGID_00000103248203037284366270000010205154239752572338_);}\r\n\t.st5{fill:url(#SVGID_00000003084370205049863960000006276029081818010769_);}\r\n\t.st6{fill:url(#SVGID_00000101067865808616000090000009702198888055148419_);}\r\n\t.st7{fill:url(#SVGID_00000003820213518729158820000015532886789340272546_);}\r\n\t.st8{fill:url(#SVGID_00000096779876198057411160000001272700382621927590_);}\r\n\t.st9{fill:url(#SVGID_00000035509435912489389950000009506471910261507976_);}\r\n\t.st10{fill:url(#SVGID_00000141457277090985057180000007813745262123219636_);}\r\n\t.st11{fill:url(#SVGID_00000104670148452668184930000011775912343040164492_);}\r\n\t.st12{fill:url(#SVGID_00000152257327228334662590000004891310426723526591_);}\r\n\t.st13{fill:url(#SVGID_00000173122371711647351720000016858899033057214862_);}\r\n\t.st14{fill:url(#SVGID_00000012450694704396915060000011481525321571759260_);}\r\n\t.st15{fill:url(#SVGID_00000026868200781913791740000006074731905704204168_);}\r\n\t.st16{fill:url(#SVGID_00000078043062155408926710000003578261461926458268_);}\r\n\t.st17{fill:#FFFFFF;}\r\n\t.st18{fill:#333333;}\r\n\t.st19{fill:url(#SVGID_00000065035556278989014280000010588442699693657779_);}\r\n")), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_1_",
    gradientUnits: "userSpaceOnUse",
    x1: 47.6323,
    y1: 137.2636,
    x2: 225.6968,
    y2: -67.1235,
    gradientTransform: "matrix(1 0 -0.2126 1 109.052 0)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.1482,
    style: {
      stopColor: "#F5A0BD"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7714,
    style: {
      stopColor: "#F57AA4"
    }
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M226.26,44.45c3.59,2.16,6.06,5.17,7.42,9.05c1.36,3.88,1.51,8.31,0.44,13.3c-1.05,4.94-3.09,9.35-6.12,13.23 c-3.03,3.88-6.8,6.92-11.31,9.12c-4.52,2.21-9.44,3.31-14.77,3.31h-20.28l10.89-51.24h20.28 C218.19,41.21,222.67,42.29,226.26,44.45z M214.04,76.46c2.86-2.28,4.73-5.5,5.62-9.67c0.9-4.22,0.4-7.47-1.48-9.78 c-1.88-2.3-4.91-3.45-9.08-3.45h-4.94l-5.59,26.31h4.94C207.66,79.88,211.18,78.74,214.04,76.46z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000126304823446214411910000009142301952721710771_",
    gradientUnits: "userSpaceOnUse",
    x1: 85.0084,
    y1: 169.8262,
    x2: 263.0729,
    y2: -34.5609,
    gradientTransform: "matrix(1 0 -0.2126 1 109.052 0)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.1482,
    style: {
      stopColor: "#F5A0BD"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7714,
    style: {
      stopColor: "#F57AA4"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000126304823446214411910000009142301952721710771_)"
    },
    d: "M265.62,84.09h-18.17l-4.54,8.36h-14.97 l29.57-51.24h16.43l7.72,51.24h-15.05L265.62,84.09z M264.38,73.19l-2-16.57l-8.97,16.57H264.38z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000026870010474107668410000014209081876487671974_",
    gradientUnits: "userSpaceOnUse",
    x1: 100.9867,
    y1: 183.7466,
    x2: 279.0512,
    y2: -20.6404,
    gradientTransform: "matrix(1 0 -0.2126 1 109.052 0)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.1482,
    style: {
      stopColor: "#F5A0BD"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7714,
    style: {
      stopColor: "#F57AA4"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000026870010474107668410000014209081876487671974_)"
    },
    d: "M310.26,41.21l-10.89,51.24h-14.25 l10.89-51.24H310.26z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000136372059265526226660000012274436364509239721_",
    gradientUnits: "userSpaceOnUse",
    x1: 118.3626,
    y1: 198.8848,
    x2: 296.4272,
    y2: -5.5023,
    gradientTransform: "matrix(1 0 -0.2126 1 109.052 0)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.1482,
    style: {
      stopColor: "#F5A0BD"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7714,
    style: {
      stopColor: "#F57AA4"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000136372059265526226660000012274436364509239721_)"
    },
    d: "M324.29,81.55h15.92l-2.32,10.9h-30.16 l10.89-51.24h14.25L324.29,81.55z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000131353628433048974430000008281835087589120692_",
    gradientUnits: "userSpaceOnUse",
    x1: 132.6432,
    y1: 211.3262,
    x2: 310.7077,
    y2: 6.9391,
    gradientTransform: "matrix(1 0 -0.2126 1 109.052 0)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.1482,
    style: {
      stopColor: "#F5A0BD"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7714,
    style: {
      stopColor: "#F57AA4"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000131353628433048974430000008281835087589120692_)"
    },
    d: "M393.02,41.21l-25.46,34.96l-3.46,16.28 h-14.32l3.46-16.28l-10.59-34.96h16.28l4.81,19.77l13.22-19.77H393.02z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000183220343971066269120000013377751180558021763_",
    gradientUnits: "userSpaceOnUse",
    x1: 80.4818,
    y1: 165.8825,
    x2: 258.5463,
    y2: -38.5046,
    gradientTransform: "matrix(1 0 -0.2126 1 109.052 0)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.1482,
    style: {
      stopColor: "#F5A0BD"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7714,
    style: {
      stopColor: "#F57AA4"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000183220343971066269120000013377751180558021763_)"
    },
    d: "M173.35,153.31 c-3.23-2.83-4.42-6.89-3.59-12.17h15.19c-0.24,1.79,0.02,3.1,0.76,3.92c0.74,0.82,1.85,1.24,3.3,1.24c1.31,0,2.46-0.33,3.44-0.98 c0.99-0.65,1.6-1.56,1.85-2.73c0.32-1.5-0.14-2.67-1.37-3.49c-1.23-0.82-3.31-1.74-6.25-2.76c-3.11-1.11-5.58-2.19-7.42-3.23 s-3.31-2.57-4.41-4.58c-1.1-2.01-1.3-4.64-0.61-7.89c0.7-3.29,2.12-6.12,4.27-8.47c2.15-2.35,4.8-4.13,7.97-5.34 c3.16-1.21,6.59-1.82,10.27-1.82c5.96,0,10.42,1.39,13.4,4.18c2.97,2.79,4.04,6.7,3.21,11.74H197.9c0.28-1.55,0.06-2.71-0.68-3.49 c-0.73-0.77-1.8-1.16-3.2-1.16c-1.07,0-2.01,0.32-2.82,0.95c-0.81,0.63-1.34,1.53-1.59,2.69c-0.21,0.97-0.01,1.81,0.59,2.51 c0.6,0.7,1.41,1.31,2.41,1.82c1.01,0.51,2.52,1.15,4.53,1.93c3.01,1.12,5.45,2.22,7.33,3.31c1.88,1.09,3.37,2.62,4.48,4.58 c1.11,1.96,1.34,4.45,0.71,7.45c-0.65,3.05-1.99,5.79-4.03,8.21c-2.04,2.42-4.65,4.34-7.84,5.74s-6.74,2.11-10.66,2.11 C181.17,157.56,176.58,156.15,173.35,153.31z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000026867023749697370940000000383997627650798006_",
    gradientUnits: "userSpaceOnUse",
    x1: 108.854,
    y1: 190.6008,
    x2: 286.9185,
    y2: -13.7863,
    gradientTransform: "matrix(1 0 -0.2126 1 109.052 0)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.1482,
    style: {
      stopColor: "#F5A0BD"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7714,
    style: {
      stopColor: "#F57AA4"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000026867023749697370940000000383997627650798006_)"
    },
    d: "M223.62,154.18 c-3.54-2.25-6.06-5.38-7.56-9.38c-1.5-4-1.72-8.52-0.64-13.56c1.07-5.04,3.21-9.56,6.41-13.56c3.2-4,7.05-7.11,11.54-9.34 c4.49-2.23,9.14-3.34,13.94-3.34c4.84,0,9.03,1.12,12.55,3.34c3.52,2.23,6.02,5.34,7.5,9.34c1.48,4,1.68,8.52,0.61,13.56 c-1.07,5.04-3.19,9.56-6.37,13.56c-3.17,4-7.01,7.12-11.51,9.38c-4.5,2.25-9.15,3.38-13.95,3.38S227.16,156.44,223.62,154.18z  M248.31,140.77c2.61-2.37,4.34-5.55,5.19-9.52c0.87-4.07,0.49-7.28-1.12-9.63c-1.61-2.35-4.23-3.53-7.86-3.53 c-3.68,0-6.82,1.18-9.4,3.53c-2.58,2.35-4.31,5.56-5.17,9.63c-0.86,4.02-0.49,7.21,1.09,9.56c1.58,2.35,4.22,3.53,7.9,3.53 C242.57,144.34,245.69,143.15,248.31,140.77z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000165196171388039644000000006591991420680154294_",
    gradientUnits: "userSpaceOnUse",
    x1: 140.4303,
    y1: 218.1104,
    x2: 318.4948,
    y2: 13.7233,
    gradientTransform: "matrix(1 0 -0.2126 1 109.052 0)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.1482,
    style: {
      stopColor: "#F5A0BD"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7714,
    style: {
      stopColor: "#F57AA4"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000165196171388039644000000006591991420680154294_)"
    },
    d: "M277.67,117.84 c2.95-3.95,6.59-7.03,10.94-9.23c4.35-2.2,9.04-3.31,14.08-3.31c6.4,0,11.41,1.71,15.05,5.12c3.63,3.42,5.46,8.06,5.47,13.92 h-15.34c-0.51-1.94-1.47-3.42-2.87-4.43c-1.41-1.02-3.18-1.53-5.31-1.53c-3.3,0-6.17,1.17-8.64,3.53 c-2.46,2.35-4.11,5.49-4.94,9.41c-0.84,3.97-0.54,7.14,0.93,9.49c1.46,2.35,3.84,3.53,7.14,3.53c2.13,0,4.12-0.51,5.96-1.53 c1.84-1.02,3.43-2.5,4.76-4.43h15.34c-2.51,5.86-6.3,10.5-11.39,13.92c-5.09,3.42-10.83,5.12-17.23,5.12 c-5.04,0-9.26-1.1-12.67-3.31c-3.41-2.21-5.75-5.28-7.01-9.23c-1.27-3.95-1.36-8.47-0.28-13.56 C272.71,126.29,274.72,121.79,277.67,117.84z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000159455246012413470280000005215752150938174626_",
    gradientUnits: "userSpaceOnUse",
    x1: 161.8627,
    y1: 236.7825,
    x2: 339.9272,
    y2: 32.3954,
    gradientTransform: "matrix(1 0 -0.2126 1 109.052 0)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.1482,
    style: {
      stopColor: "#F5A0BD"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7714,
    style: {
      stopColor: "#F57AA4"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000159455246012413470280000005215752150938174626_)"
    },
    d: "M347.33,105.81l-10.89,51.24h-14.25 l10.89-51.24H347.33z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000008871681855341221760000003338958312502689665_",
    gradientUnits: "userSpaceOnUse",
    x1: 188.4409,
    y1: 259.9378,
    x2: 366.5054,
    y2: 55.5507,
    gradientTransform: "matrix(1 0 -0.2126 1 109.052 0)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.1482,
    style: {
      stopColor: "#F5A0BD"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7714,
    style: {
      stopColor: "#F57AA4"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000008871681855341221760000003338958312502689665_)"
    },
    d: "M377.55,148.7h-18.17l-4.54,8.36h-14.97 l29.57-51.24h16.43l7.72,51.24h-15.05L377.55,148.7z M376.31,137.79l-2-16.57l-8.97,16.57H376.31z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000090295201381007981150000008580648757127848383_",
    gradientUnits: "userSpaceOnUse",
    x1: 208.9478,
    y1: 277.8037,
    x2: 387.0123,
    y2: 73.4166,
    gradientTransform: "matrix(1 0 -0.2126 1 109.052 0)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.1482,
    style: {
      stopColor: "#F5A0BD"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7714,
    style: {
      stopColor: "#F57AA4"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000090295201381007981150000008580648757127848383_)"
    },
    d: "M413.62,146.15h15.92l-2.32,10.9h-30.16 l10.89-51.24h14.25L413.62,146.15z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000126282419007281743170000003632335333521220229_",
    gradientUnits: "userSpaceOnUse",
    x1: 112.0518,
    y1: 193.3867,
    x2: 290.1164,
    y2: -11.0003,
    gradientTransform: "matrix(1 0 -0.2126 1 109.052 0)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.1482,
    style: {
      stopColor: "#F5A0BD"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7714,
    style: {
      stopColor: "#F57AA4"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000126282419007281743170000003632335333521220229_)"
    },
    d: "M198.68,199.82 c1.28,2.3,1.61,4.93,0.98,7.89c-0.93,4.36-3.16,7.78-6.69,10.25c-3.53,2.47-8.01,3.71-13.43,3.71h-25.37l10.89-51.24h24.57 c5.23,0,9.09,1.16,11.58,3.49c2.49,2.33,3.28,5.6,2.38,9.81c-0.64,3-1.96,5.51-3.96,7.52c-2,2.01-4.39,3.38-7.16,4.11 C195.33,196.02,197.4,197.51,198.68,199.82z M174.98,190.77h7.2c3.58,0,5.69-1.48,6.32-4.43c0.65-3.05-0.82-4.58-4.4-4.58h-7.2 L174.98,190.77z M185.48,205.67c0.33-1.55,0.11-2.74-0.66-3.56c-0.77-0.82-2.03-1.24-3.77-1.24h-8.21l-1.98,9.3h8.29 C182.73,210.17,184.84,208.67,185.48,205.67z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000088824930837282867010000001457410983540742538_",
    gradientUnits: "userSpaceOnUse",
    x1: 143.0737,
    y1: 220.4133,
    x2: 321.1382,
    y2: 16.0262,
    gradientTransform: "matrix(1 0 -0.2126 1 109.052 0)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.1482,
    style: {
      stopColor: "#F5A0BD"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7714,
    style: {
      stopColor: "#F57AA4"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000088824930837282867010000001457410983540742538_)"
    },
    d: "M213.79,218.79 c-3.54-2.25-6.06-5.38-7.56-9.38c-1.5-4-1.72-8.52-0.64-13.56c1.07-5.04,3.21-9.56,6.41-13.56c3.2-4,7.05-7.11,11.54-9.34 c4.49-2.23,9.14-3.34,13.94-3.34c4.84,0,9.03,1.12,12.55,3.34c3.52,2.23,6.02,5.34,7.5,9.34c1.48,4,1.68,8.52,0.61,13.56 c-1.07,5.04-3.19,9.56-6.37,13.56c-3.17,4-7.01,7.12-11.51,9.38c-4.5,2.25-9.15,3.38-13.95,3.38S217.34,221.04,213.79,218.79z  M238.49,205.38c2.61-2.37,4.34-5.55,5.19-9.52c0.87-4.07,0.49-7.28-1.12-9.63c-1.61-2.35-4.23-3.53-7.86-3.53 c-3.68,0-6.82,1.18-9.4,3.53c-2.58,2.35-4.31,5.56-5.17,9.63c-0.85,4.02-0.49,7.21,1.09,9.56c1.58,2.35,4.22,3.53,7.9,3.53 C232.75,208.94,235.87,207.75,238.49,205.38z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000047755855470735322420000009917728784849233588_",
    gradientUnits: "userSpaceOnUse",
    x1: 174.9236,
    y1: 248.1614,
    x2: 352.9881,
    y2: 43.7743,
    gradientTransform: "matrix(1 0 -0.2126 1 109.052 0)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.1482,
    style: {
      stopColor: "#F5A0BD"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7714,
    style: {
      stopColor: "#F57AA4"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000047755855470735322420000009917728784849233588_)"
    },
    d: "M269.82,218.79 c-3.54-2.25-6.06-5.38-7.56-9.38c-1.5-4-1.72-8.52-0.64-13.56c1.07-5.04,3.21-9.56,6.41-13.56c3.2-4,7.05-7.11,11.54-9.34 c4.49-2.23,9.14-3.34,13.94-3.34c4.84,0,9.03,1.12,12.55,3.34c3.52,2.23,6.02,5.34,7.5,9.34c1.48,4,1.68,8.52,0.61,13.56 c-1.07,5.04-3.19,9.56-6.37,13.56c-3.17,4-7.01,7.12-11.51,9.38c-4.5,2.25-9.15,3.38-13.95,3.38S273.36,221.04,269.82,218.79z  M294.51,205.38c2.61-2.37,4.34-5.55,5.19-9.52c0.87-4.07,0.49-7.28-1.12-9.63c-1.61-2.35-4.23-3.53-7.86-3.53 c-3.68,0-6.82,1.18-9.4,3.53c-2.58,2.35-4.31,5.56-5.17,9.63c-0.86,4.02-0.49,7.21,1.09,9.56c1.58,2.35,4.22,3.53,7.9,3.53 C288.78,208.94,291.9,207.75,294.51,205.38z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000088127932872361352060000005116754860789119668_",
    gradientUnits: "userSpaceOnUse",
    x1: 203.3387,
    y1: 272.917,
    x2: 381.4033,
    y2: 68.5299,
    gradientTransform: "matrix(1 0 -0.2126 1 109.052 0)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.1482,
    style: {
      stopColor: "#F5A0BD"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7714,
    style: {
      stopColor: "#F57AA4"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000088127932872361352060000005116754860789119668_)"
    },
    d: "M319.44,217.91 c-3.23-2.83-4.42-6.89-3.59-12.17h15.19c-0.24,1.79,0.02,3.1,0.76,3.92c0.74,0.82,1.85,1.24,3.3,1.24c1.31,0,2.46-0.33,3.44-0.98 s1.6-1.56,1.85-2.73c0.32-1.5-0.14-2.67-1.37-3.49c-1.23-0.82-3.31-1.74-6.25-2.76c-3.11-1.11-5.58-2.19-7.42-3.23 c-1.84-1.04-3.31-2.57-4.41-4.58s-1.3-4.64-0.61-7.89c0.7-3.29,2.12-6.12,4.27-8.47c2.15-2.35,4.8-4.13,7.97-5.34 c3.16-1.21,6.59-1.82,10.27-1.82c5.96,0,10.42,1.39,13.39,4.18c2.97,2.79,4.04,6.7,3.21,11.74h-15.48 c0.28-1.55,0.06-2.71-0.68-3.49c-0.73-0.77-1.8-1.16-3.2-1.16c-1.07,0-2.01,0.32-2.82,0.95c-0.81,0.63-1.34,1.53-1.59,2.69 c-0.21,0.97-0.01,1.81,0.59,2.51c0.6,0.7,1.41,1.31,2.41,1.82c1.01,0.51,2.52,1.15,4.53,1.93c3.01,1.12,5.45,2.22,7.33,3.31 c1.88,1.09,3.37,2.62,4.48,4.58c1.11,1.96,1.34,4.45,0.71,7.45c-0.65,3.05-1.99,5.79-4.03,8.21c-2.04,2.42-4.65,4.34-7.84,5.74 s-6.74,2.11-10.66,2.11C327.26,222.17,322.67,220.75,319.44,217.91z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000024699584650208222460000007749738954239644071_",
    gradientUnits: "userSpaceOnUse",
    x1: 224.1676,
    y1: 291.0633,
    x2: 402.2321,
    y2: 86.6762,
    gradientTransform: "matrix(1 0 -0.2126 1 109.052 0)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.1482,
    style: {
      stopColor: "#F5A0BD"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7714,
    style: {
      stopColor: "#F57AA4"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000024699584650208222460000007749738954239644071_)"
    },
    d: "M407.33,170.41l-2.41,11.34h-13.67 l-8.48,39.9h-14.25l8.48-39.9h-13.52l2.41-11.34H407.33z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000049195954895583456450000007192254090513342649_",
    gradientUnits: "userSpaceOnUse",
    x1: -205.9412,
    y1: 288.0389,
    x2: -106.9034,
    y2: 288.0389,
    gradientTransform: "matrix(0.9749 -0.2225 0.2225 0.9749 186.8369 -182.6394)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.1482,
    style: {
      stopColor: "#F5A0BD"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7714,
    style: {
      stopColor: "#F57AA4"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000049195954895583456450000007192254090513342649_)"
    },
    d: "M127.14,74.09L47.02,92.37 c-4.54,1.04-7.38,5.55-6.34,10.09l15.31,67.11c1.04,4.54,5.55,7.38,10.09,6.34l59.97-13.68l19.59,12.31L142,158.58l4.19-0.96 c4.54-1.04,7.38-5.55,6.34-10.09l-15.31-67.11C136.19,75.89,131.67,73.05,127.14,74.09z"
  }), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    className: "st17",
    points: "73.02,142.58 80.73,125.16 70.76,108.94 89.7,110.89 102.05,96.4 106.04,115.02 123.65,122.28  107.17,131.83 105.71,150.82 91.53,138.11  "
  }))), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "st18",
    d: "M144.05,31.13l-55.24-3.27c-9.22-0.55-17.14,6.49-17.68,15.71l-1.14,19.34c-0.43,7.19,3.79,13.54,10.03,16.27 l-1.14,19.27l19.27-17.11l42.78,2.53c9.22,0.55,17.14-6.49,17.68-15.71l1.14-19.34C160.3,39.6,153.27,31.68,144.05,31.13z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000111899326864033482180000000668094510832805055_",
    gradientUnits: "userSpaceOnUse",
    x1: 100.2782,
    y1: 61.8767,
    x2: 123.762,
    y2: 47.1671
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.1482,
    style: {
      stopColor: "#F5A0BD"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7714,
    style: {
      stopColor: "#F57AA4"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000111899326864033482180000000668094510832805055_)"
    },
    d: "M131.6,51.53 c0.25-4.68-3.34-8.68-8.02-8.93c-4.32-0.23-8.03,2.83-8.77,6.98c-0.07-0.01-0.14-0.03-0.21-0.03c-0.3-4.2-3.65-7.63-7.97-7.86 c-4.68-0.25-8.68,3.34-8.93,8.02c-0.14,2.65,0.97,5.05,2.79,6.71l-0.02,0.01l13.06,15.22l0,0l14.62-13.73l-0.02-0.01 C130.09,56.45,131.45,54.18,131.6,51.53z"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDsbLogo);
export default __webpack_public_path__ + "static/media/DSB-Logo.ae76e9375c7c00b0d2eee716cd0f41cd.svg";
export { ForwardRef as ReactComponent };